import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";
import { DYNAMIC_PROCESS_FORM } from "../dynamic-process-form-provider/forms-enum";
import { DynamicProcessModelForm } from "../dynamic-process-model-form";
import { FieldsType, Model } from "../../model/types";

export function GeneralForm({ model }: { model: Model }) {
  return (
    <DynamicProcessModelForm
      name={DYNAMIC_PROCESS_FORM.MODEL}
      initialValues={
        {
          id: model?.id,
          name: extractLocalizedValue(model?.name),
          allowAttachments: model?.allowAttachments,
          active: model?.active ?? true,
          icon: model?.icon?.id,
        } as FieldsType
      }
    />
  );
}
